import { IImportProcess, IImportProcessTypes } from './types';

export function createImportProcessRequest(
  referenceId: string,
  type: string,
  operation: string,
  fileName: string,
  createdById: number,
  successPushUrl?: string,
) {
  return {
    type: IImportProcessTypes.CREATE_IMPORT_PROCESS_REQUEST,
    payload: {
      referenceId,
      type,
      operation,
      fileName,
      createdById,
      successPushUrl,
    },
  };
}

export function createImportProcessSuccess() {
  return {
    type: IImportProcessTypes.CREATE_IMPORT_PROCESS_SUCCESS,
  };
}

export function createImportProcessFailure() {
  return {
    type: IImportProcessTypes.CREATE_IMPORT_PROCESS_FAILURE,
  };
}

export function getLatestImportProcessRequest(referenceId: string) {
  return {
    type: IImportProcessTypes.GET_LATEST_IMPORT_PROCESS_REQUEST,
    payload: {
      referenceId,
    },
  };
}

export function getLatestImportProcessSuccess(importProcess: IImportProcess) {
  return {
    type: IImportProcessTypes.GET_LATEST_IMPORT_PROCESS_SUCCESS,
    payload: {
      importProcess,
    },
  };
}

export function getLatestImportProcessFailure() {
  return {
    type: IImportProcessTypes.GET_LATEST_IMPORT_PROCESS_FAILURE,
  };
}
